import { useAnalytics } from 'use-analytics';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageTracker = () => {
  const { page } = useAnalytics();
  const { pathname } = useLocation();

  useEffect(() => {
    if (page) page();
  }, [pathname, page]);
};

export default usePageTracker;
